import { Helpers } from '../../helpers';
import { IGelWeight } from '../../interfaces/igel-weight';
import { ScenarioWell } from '../scenario-well';

export class GelWeightBase {
  GelWeightId: number;
  Weight: number;
  Uom: number;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_GelWeight?: Array<ScenarioWell> | null;

  constructor(item?: IGelWeight) {
    if (item) {

      this.GelWeightId = item.GelWeightId;
      this.Weight = item.Weight;
      this.Uom = item.Uom;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_GelWeight = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_GelWeight);
    }
  }
}